module.exports = __webpack_public_path__ + "img/Logo_Area_Completo.a07aad74.png";